module.exports = __webpack_public_path__ + "static/media/new_msg.8617c6cb.mp3";